module.exports = __webpack_public_path__ + "static/img/register_bg.620ec4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/register_bg.png
// module id = PSDG
// module chunks = 2